export function importModule(url: string) {
    /* This prevents webpack from compiling the import, allowing it to be
     * provided to the bundle "as is" for dynamic acquisition of ES6 modules
     * https://webpack.js.org/api/module-methods/#webpackignore
     */
    return import(/* webpackIgnore:true */ url);
}
